import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { toast } from 'react-hot-toast'
import { useTRPC } from '../../hooks'

export const useTransferDashboard = () => {
  const queryClient = useQueryClient()

  const api = useTRPC()
  const transferMutationOptions =
    api.shared.dashboards.transfer.mutationOptions({
      onSuccess: () => {
        void queryClient.invalidateQueries({
          queryKey: api.shared.dashboards.pathKey(),
        })
      },
    })

  const { mutateAsync, isPending } = useMutation(transferMutationOptions)

  const transferDashboard = useCallback(
    async (id: string, newUserEmail: string) => {
      const mutationPromise = mutateAsync({
        id,
        newUserEmail,
      })

      await toast.promise(mutationPromise, {
        loading: 'Transferring dashboard...',
        success: 'Dashboard transferred successfully',
        error: (error: Error) =>
          error.message ||
          'Could not transfer dashboard, please try again later',
      })
    },
    [mutateAsync]
  )

  return { transferDashboard, isTransferring: isPending }
}
